import { createFileRoute } from "@tanstack/react-router";
import { matchRoute } from "@/app-clients/matching-flow/match-route-data";
import { MatchRoutePage } from "@/app-clients/matching-flow/match-route";

export const Route = createFileRoute("/match")({
    validateSearch: matchRoute.validateSearch,
    loaderDeps: matchRoute.loaderDeps,
    ssr: matchRoute.ssr,
    preload: false,
    beforeLoad: matchRoute.beforeLoad,
    loader: matchRoute.loader,
    head: matchRoute.head,
    component: MatchRoutePage,
});
